import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import SubscriptionForm from './components/SubscriptionForm';
import './App.scss';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Header />
      
      <div className="app-container" data-bs-theme="dark">
        <Routes>
          {/* Rota raiz - Home */}
          <Route path="/" element={<Home />} />
          
          {/* /planos/:planId - Checkout com plano pré-selecionado via link do assessor */}
          <Route 
            path="/planos/:planId" 
            element={
              <Container>
                <Row className="justify-content-center">
                  <Col lg={8} xl={7}>
                    <SubscriptionForm />
                  </Col>
                </Row>
              </Container>
            } 
          />
          
          {/* /planos sem ID e qualquer 404 redirecionam para home */}
          <Route path="/planos" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      
      <Footer />
    </BrowserRouter>
  );
}

export default App;
